G.MysteryGiftHeaderInGame = function(peak) {
  G.MysteryGiftHeader.call(this, peak);

  this.state = game.state.getCurrentState();
  this.board = this.state.board;

  this.x = this.board.x+(this.board.width-this.board.tilesize*2)*0.5;
  this.y = -300;

  game.add.tween(this).to({y: 80}, 600, Phaser.Easing.Sinusoidal.Out, true, 0)
  .onComplete.add(function() {
    game.add.tween(this).to({y: -300}, 600, Phaser.Easing.Sinusoidal.In, true, 2500);
  }, this);
};

G.MysteryGiftHeaderInGame.prototype = Object.create(G.MysteryGiftHeader.prototype);